import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    ticketReplyList: {
      requesting: false,
      items: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
      error: null,
      success: false,
      filters: {},
    },
    ticketReplyDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const ticketReplySlice = createSlice({
  name: 'ticketReply',
  initialState,
  reducers: {
    getTicketReplyList: (state, action) => {
      state.ticketReplyList.requesting = true;
      state.ticketReplyList.error = null;
      state.ticketReplyList.items = [];
      state.ticketReplyList.success = false;
      state.ticketReplyList.filters = action.payload;
    },
    getTicketReplyListSuccess: (state, action) => {
      const { data, current_page, per_page, total} = action.payload;
      state.ticketReplyList.requesting = false;        
      state.ticketReplyList.items = data;
      state.ticketReplyList.success = true; 
      state.ticketReplyList.pagination.current_page = current_page;
      state.ticketReplyList.pagination.per_page = per_page;
      state.ticketReplyList.pagination.total = total;
    },
    getTicketReplyListFail: (state, action) => {        
      state.ticketReplyList.requesting = false;
      state.ticketReplyList.error = action.payload;
    },
    getTicketReplyDetails: (state) => {
      state.ticketReplyDetails.requesting = true;
      state.ticketReplyDetails.error = null;
      state.ticketReplyDetails.data = null;
      state.ticketReplyDetails.success = false; 
    },
    getTicketReplyDetailsSuccess: (state, action) => {
      state.ticketReplyDetails.requesting = false;
      state.ticketReplyDetails.data = action.payload;
      state.ticketReplyDetails.success = true; 
    },
    getTicketReplyDetailsFail: (state, action) => {        
      state.ticketReplyDetails.requesting = false;
      state.ticketReplyDetails.error = action.payload;
    },

    doTicketReplyCreate: (state) => {
      state.ticketReplyDetails.requesting = true;
      state.ticketReplyDetails.error = null;
      state.ticketReplyDetails.data = null;
      state.ticketReplyDetails.success = false; 
    },
  },
})

export const { 
    getTicketReplyList, getTicketReplyListSuccess, getTicketReplyListFail,
    getTicketReplyDetails, getTicketReplyDetailsSuccess, getTicketReplyDetailsFail,
    doTicketReplyCreate,
} = ticketReplySlice.actions

export default ticketReplySlice.reducer